// @flow
import type {UserAgentDeviceFlags} from '../../server/utils/systemData';

export const VIEWPORT_SIZE_CHANGED = 'VIEWPORT/SIZE_CHANGED';
export const VIEWPORT_USER_AGENT_CHANGED = 'VIEWPORT/USER_AGENT_CHANGED';

type ViewportSizeChangedActionType = typeof VIEWPORT_SIZE_CHANGED;
type ViewportUserAgentChangedActionType = typeof VIEWPORT_USER_AGENT_CHANGED;
export type ActionType =
    | ViewportSizeChangedActionType
    | ViewportUserAgentChangedActionType;

type Size = {
    width: number,
    height: number
};

export type ViewportSizeChangedAction = {|
    type: ViewportSizeChangedActionType,
    payload: Size
|};
export type ViewportUserAgentChangedAction = {|
    type: ViewportUserAgentChangedActionType,
    payload: UserAgentDeviceFlags
|};
export type Action = ViewportSizeChangedAction | ViewportUserAgentChangedAction;

const ACTION_CREATORS = {
    sizeChanged(size: Size): ViewportSizeChangedAction {
        return {
            type: VIEWPORT_SIZE_CHANGED,
            payload: {
                ...size
            }
        };
    },
    userAgentChanged(
        flags: UserAgentDeviceFlags
    ): ViewportUserAgentChangedAction {
        return {
            type: VIEWPORT_USER_AGENT_CHANGED,
            payload: flags
        };
    }
};

export default {
    ...ACTION_CREATORS
};
